import * as actionTypes from "./actionTypes";
import * as commonActionTypes from "../shared/commonActionTypes";

const initialState = {
    showClosedMatters: false,
    isSearched: false
  };

const reducer = (state = initialState, action) => {
    switch (action.type ){
        case actionTypes.SET_SEARCH:
        return {
            ...state,
            isSearched: action.isSearched
        }
        case actionTypes.SET_ARCHIVE:
        return {
            ...state,
            showClosedMatters: action.showClosedMatters
        }
        case commonActionTypes.LOGOUT:
            return initialState
        default:
        return state;        
    }    
}

export default reducer;